"use client"

import { useEffect, useMemo, useState, type ReactNode } from "react"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"

import { makePersistStore, makeStore, type AppStore } from "@/lib/store"

type Props = {
  children: ReactNode
}

export function StoreProvider({ children }: Props) {
  const { store, persistor } = useMemo(() => {
    const store = makeStore()
    const persistor = makePersistStore(store)
    return { store, persistor }
  }, [])

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {children}
      </PersistGate>
    </Provider>
  )
}

export type { AppStore }
